/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

console.log('Custom js');
window.addEventListener('load', ()=> {
  updateTotalPrice()
  initUpdateQuantityByBtn()
  initUpdateQuantityByInput()  
  searchVariantProducts()
  liveSearch()
  initLocalStorageProductFromCart()
  accountTabsNavigation()
  setActiveAccountTab()

  setTimeout(()=>{
    loginPopupForm()
    
    /* Add addEventListener for the buttons on the PLP after sorting */
    const filters = document.querySelectorAll('.value-picker__choice-list .value-picker__choice-item')
    if( filters ){  
      filters.forEach((filterBtn)=>{
        filterBtn.addEventListener('click', function(){
            setTimeout(()=>{
              loginPopupForm()
            }, 2000)
        })
      })
    }    
  }, 1000)

})


function addItemsToCart(){
    let products = []
    let variants = document.querySelectorAll('.quantity-variant-product');
    variants.forEach((variant) => {

        let variant_id = variant.getAttribute('data-variant-id');
        let variant_quantity = parseInt(variant.querySelector('.quantity-input').value);

        if(variant_quantity > 0){
          products.push({
              id: variant_id,
              quantity: variant_quantity
          })
        }
    });

    const cartLineStatus = checkCartItemLines()

    if( (products.length > 0) && cartLineStatus.status ){
      addMultipleProductsToCart(products)
    }
}

function addMultipleProductsToCart(products) {
  // console.log("Products to cart: ", products);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: products.map(product => ({
        id: product.id, // Variant ID of the product
        quantity: product.quantity, // Quantity to add
      })),
    }),
  })
  .then(response => response.json())
  .then(data => {
    if(data.status == 422){
      // console.log(data);
      document.querySelector("#error-msg-wrap").textContent = "Order limit reached, please break into two orders or reach out to us directly"
      document.querySelector("#error-msg-wrap").style.display = 'block';
    } else {
      clearInputFields()
      addCartProductsToLocalStorage(products)
      window.location.href = '/cart';
    }
    
  })
  .catch(error => console.error('Error:', error));
}
// Example usage
// addMultipleProductsToCart([
//   { id: 1234567890, quantity: 1 },  // Replace with actual variant IDs and quantities
//   { id: 9876543210, quantity: 2 },
// ]);

function initUpdateQuantityByInput(){
  let quantityInputs = document.querySelectorAll('.quantity-input')
  quantityInputs.forEach((inputField) => {
    inputField.addEventListener('keyup', function(){
      const inventoryQuantity = parseInt(this.getAttribute('max'));
      let quantityInput = parseInt(this.value);
      
      if( quantityInput < 0){
        quantityInput = 0
        this.value = 0
      }
      
      if( quantityInput > inventoryQuantity ){
        this.value = inventoryQuantity
        return
      }
      
      const cartLineStatus = checkCartItemLines()
      const variantID = this.parentElement.parentElement.getAttribute("data-variant-id")
      const maxAvailabilityQuantity = checkCurrentMaxAvailabilityQuantity(variantID, quantityInput, inventoryQuantity)
      
      if( cartLineStatus.status ){
        if( maxAvailabilityQuantity < quantityInput ){
          this.value = maxAvailabilityQuantity
        }
        updateTotalPrice()
      } else {
        this.value = 0
        limitCartLinesError(cartLineStatus)
      }
    })
  })
}

function initUpdateQuantityByBtn(){
  let quantityUpdateBtn = document.querySelectorAll('.quantity-update')
  
  quantityUpdateBtn.forEach((item)=>{
    item.addEventListener('click', function(){
      document.querySelector("#error-msg-wrap").textContent = ""
      document.querySelector("#error-msg-wrap").style.display = 'none';
      updateQuantity(this)
    })
  })
}

function updateQuantity(quantityBtn){
  const parentEl = quantityBtn.parentElement;
  const inventoryQuantity = parseInt(parentEl.querySelector('.quantity-input').getAttribute('max'))
  let quantityInput = parseInt(parentEl.querySelector('.quantity-input').value)
  const variantId = parentEl.getAttribute('data-variant-id')

  // console.log(quantityInput > (inventoryQuantity - 1))
  
  if( quantityBtn.classList.contains('minus-quantity') ){
    parentEl.querySelector('.plus-quantity').classList.remove('limit')
    if( quantityInput == 0 ) {
      return
    } else {
      quantityInput = quantityInput - 1;
    }
  } else {
    quantityInput = quantityInput + 1;
    const quantityStatus = checkProductsQuantityInCart(variantId, quantityInput)
    if( (quantityInput > inventoryQuantity) || !quantityStatus ){
      quantityBtn.classList.add('limit')
      return
    }
  }

  const cartLineStatus = checkCartItemLines()
  
  if( cartLineStatus.status ){
    parentEl.querySelector('.quantity-input').value = quantityInput
    updateTotalPrice()
  } else {
    parentEl.querySelector('.quantity-input').value = 0
    limitCartLinesError(cartLineStatus)
  }
}

function clearInputFields (){
  let quantityInputs = document.querySelectorAll('.quantity-input')
  quantityInputs.forEach((inputField) => {
    inputField.value = 0
  })
}

function updateTotalPrice(){
  // console.log("Update total price");
  const quantityInputs = document.querySelectorAll('.quantity-input')
  const curentTotalPrice = document.querySelector('.current-total-price')
  let totalPrice = 0
  quantityInputs.forEach((inputField) => {
    let parentEl = inputField.parentElement.parentElement
    let productQuantity = parseInt(inputField.value)
    let productPrice = parseInt(parentEl.getAttribute('data-variant-price'))
   
    if( isNaN(productQuantity) ){
      return
    }
    totalPrice = totalPrice + (productQuantity * productPrice) 
    
    document.querySelector('.variants-total-price').setAttribute('data-total-price',totalPrice)
    let formatingPrice = (totalPrice / 100 ).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    })

    if( curentTotalPrice ){
      document.querySelector('.current-total-price').textContent = formatingPrice
    }
  })
}

function searchVariantProducts(){
  // console.log("Search...")
  let searchBtn = document.querySelector('#search-variants-btn')
  if( searchBtn ){
    document.querySelector('#search-variants-field').value = ''
    searchBtn.addEventListener('click', ()=>{
      let searchText = document.querySelector('#search-variants-field').value.toLowerCase()
      let variantProducts = document.querySelectorAll('.variant-product-item')
      
        variantProducts.forEach((variant) => {
        if(searchText != ''){
          const variantColor = variant.getAttribute('data-variant-color')
          const variantSKU = variant.getAttribute('data-variant-sku')

          if( !variantColor.includes(searchText) && !variantSKU.includes(searchText) ){
            variant.style.display = 'none'
          } else {
            variant.style.display = 'grid'
          }
        } else {
          variant.style.display = 'grid'
        }        
      })
    })
  }
}

function liveSearch(){
  const searchField = document.querySelector('#search-variants-field')
  if( searchField ){
    const variantProducts = document.querySelectorAll('.variant-product-item')
    searchField.addEventListener('keyup',() => {
      let searchText = searchField.value.toLowerCase()
      if( searchText.length > 1 ){
        variantProducts.forEach((variant) => {
          const variantColor = variant.getAttribute('data-variant-color')
          const variantSKU = variant.getAttribute('data-variant-sku')
          if( !variantColor.includes(searchText) && !variantSKU.includes(searchText) ){
            variant.style.display = 'none'
          } else {
            variant.style.display = 'grid'
          }
        })
      } else {
        variantProducts.forEach((variant) => {
          variant.style.display = 'grid'
        })
      }
    })
  }
}

function loginPopupForm(){
  const loginPopupWindow = document.querySelector('.login-popup-window')
  if( loginPopupWindow ){
    const popupCloseBtn = loginPopupWindow.querySelector('.close-popup')
    const showPopupBtns = document.querySelectorAll('.show-pupup-window')
  
    showPopupBtns.forEach((popupBtn) => {
      popupBtn.addEventListener('click', ()=>{
        loginPopupWindow.style.display = 'flex'
        document.body.setAttribute('data-popup-status', 'show')
      })
    })
  
    popupCloseBtn.addEventListener('click', () => {
      loginPopupWindow.style.display = 'none'
      document.body.setAttribute('data-popup-status', 'hide')
    })

  }
}

function checkCartItemLines(){
  const quantityInputs = document.querySelectorAll('.quantity-input')
  const cartLineStatus = {
    status: true,
    message: "Order limit reached, please break into two orders or reach out to us directly"
  }
  if( quantityInputs ){
    let currentCartCount = parseInt(document.querySelector('.variants-total-price').getAttribute('data-cart-lines'));
    quantityInputs.forEach((inputField) => {
      if( inputField.value > 0 ){
        currentCartCount = currentCartCount + 1
        if( currentCartCount > 449 ){
          cartLineStatus.status = false
        }
      }
    })
    return cartLineStatus
  }
}

function limitCartLinesError(cartLineStatus){
  document.querySelector("#error-msg-wrap").textContent = cartLineStatus.message
  document.querySelector("#error-msg-wrap").style.display = 'block';
}

function addCartProductsToLocalStorage(products){
  // console.log("Add products to local storage")
  let productsStorage = JSON.parse(localStorage.getItem('productsInCart'))
  let tempAarr = []

  if( productsStorage ){
    products.forEach((product)=>{
      let newProduct = true
      productsStorage.forEach((productStorage)=>{
        if( productStorage.id == product.id ){
          // console.log("productStorage: ", productStorage)
          // console.log("product: ", product)
          productStorage.quantity = productStorage.quantity + product.quantity
          newProduct = false
          return
        } 
      })

      if( newProduct ){
        // console.log("PUSH: ", product.id)
        tempAarr.push(product)
      }

    })
    // console.log("tempAarr: ", tempAarr)
    productsStorage = productsStorage.concat(tempAarr)
    // console.log("productsStorage: ", productsStorage)
    localStorage.setItem('productsInCart', JSON.stringify(productsStorage))  
  } else {
    localStorage.setItem('productsInCart', JSON.stringify(products))    
  }
}

function checkProductsQuantityInCart(variantID, variantQuantity){
  const products = JSON.parse(localStorage.getItem('productsInCart'))
  let status = true
  if(products){
    products.forEach((product)=>{
      if( product.id == variantID ){
        const  quantity = product.quantity + variantQuantity
        const inventory = document.querySelector(`#quantity_variant_id_${ variantID } .quantity-input`).getAttribute('max')
        if( quantity > inventory){
          status = false
          return
        }
      }
    })  
    return status
  }
  return status
}

function initLocalStorageProductFromCart(){
  const miniCartLineItems = document.querySelectorAll('.mini-cart__line-item')
  let products = []
  if( miniCartLineItems ){
    miniCartLineItems.forEach((miniCartLime)=>{
      const variantID = miniCartLime.querySelector('[data-key]').getAttribute('data-key').split(':')
      const variantQuantity = parseInt(miniCartLime.querySelector('.quantity-selector__value').getAttribute('data-current-value'))
      const product = {
        "id": variantID[0],
        "quantity": variantQuantity
      }

      products.push(product)
    })

    localStorage.setItem('productsInCart', JSON.stringify(products))
  }
}

function checkCurrentMaxAvailabilityQuantity(variantID, variantQuantity, inventoryQuantity){
  const products = JSON.parse(localStorage.getItem('productsInCart'))
  let maxAvailabilityQuantity = inventoryQuantity
  if( products ){
    products.forEach((product)=>{
      if( product.id == variantID ){
        maxAvailabilityQuantity = inventoryQuantity - product.quantity
      }
    })  
  }
  return maxAvailabilityQuantity
}

accountTabsNavigation()
function accountTabsNavigation(){
  const accountsTabLinks = document.querySelectorAll('.account-tabs-link')
  if( accountsTabLinks ){
    accountsTabLinks.forEach((tabLink)=> {
      tabLink.addEventListener('click', function(){
        removeActiveClassTabs()
        removeActiveTabLink()

        this.classList.add('text--strong')        
        this.classList.add('is-selected') 
        const tabName = this.getAttribute('data-tab-name')
        const tabBreadcrumb = this.textContent

        document.querySelector('.breadcrumb__account-tab').textContent = tabBreadcrumb 
        document.querySelector('.value-picker-button--pill span').textContent = tabBreadcrumb
        document.querySelector(`[data-tab-content=${ tabName }]`).classList.add('active')

        const tabLinks = document.querySelectorAll('.account-tabs-link')
        tabLinks.forEach((tabLink)=>{
          if( tabLink.getAttribute('data-tab-name') == tabName ){
            tabLink.classList.add('text--strong')
          }
        })
      })
    })  
  }
}

function setActiveAccountTab(){
  let hash = window.location.hash.slice(1);
  const tabLinks = document.querySelectorAll('.account-tabs-link')
  if( hash ){
    removeActiveClassTabs()
    removeActiveTabLink()
    document.querySelector(`[data-tab-content=${ hash }]`).classList.add('active')

    const tabLinks = document.querySelectorAll('.account-tabs-link')
    tabLinks.forEach((tabLink)=>{
      if( tabLink.getAttribute('data-tab-name') == hash ){
        tabLink.classList.add('text--strong')
        tabLink.classList.add('is-selected')
      }
    })
  } else {
    let pathname = window.location.pathname;
    if(  pathname.includes('orders')){
      removeActiveTabLink()
      tabLinks.forEach((tabLink)=>{
        if( tabLink.getAttribute('data-tab-name') == 'orders'){
          tabLink.classList.add('text--strong')
          tabLink.classList.add('is-selected')
        }
      })
    }
  }
}

function setActiveAccountBreadcrumbs(){
  let hash = window.location.hash.slice(1);
  document.querySelector('.breadcrumb__account-tab').textContent = tabBreadcrumb 
}

function removeActiveClassTabs(){
  const tabName = document.querySelectorAll('.tab-content')
  tabName.forEach((tabContent) => {
    tabContent.classList.remove('active')
  })
}

function removeActiveTabLink(){
  const tabLink= document.querySelectorAll('.account-tabs-link')
  tabLink.forEach((tablink) => {
    tablink.classList.remove('text--strong')
    tablink.classList.remove('is-selected')
  })
}

switchPasswordtypeField()
function switchPasswordtypeField(){
  document.querySelectorAll('.type-pass-field').forEach((passStatus)=>{
    passStatus.addEventListener('click', function(){
      const currentFormID = this.parentElement.getAttribute('data-form-id')
      const currentForm = document.querySelector(`#${ currentFormID }`)
      this.classList.remove('active')
      if( this.classList.contains('type-field-text')){
        currentForm.querySelector('.form__field--password').setAttribute('type', 'text')
        currentForm.querySelector('.type-field-pass').classList.add('active')
      } else {
        currentForm.querySelector('.form__field--password').setAttribute('type', 'password')
        currentForm.querySelector('.type-field-text').classList.add('active')
      }
    })
  }) 
}

clearCart()
function clearCart(){
  const clearCartBtn = document.querySelector('.clear-cart')
  if( clearCartBtn ){
    clearCartBtn.addEventListener('click', ()=>{
      window.location.href = '/cart/clear'
    })
  }
}